import * as requests from '@cbgms/api/modules/concepts/requests'

import * as types from './types'
import { IPaginatedRequest } from '@cbgms/api/request'
import { GETConceptResponse, GETUserShopConceptsResponse } from '@cbgms/api/modules/concepts'
import { AsyncAction } from '@cbgms/base/redux/async-action'

export const listShopConcepts = (shopUUID: string, params?: IPaginatedRequest) =>
  AsyncAction<GETUserShopConceptsResponse>({
    type: [types.GET_SHOP_CONCEPTS, types.GET_SHOP_CONCEPTS_SUCCESS, types.GET_SHOP_CONCEPTS_FAILED],
    payload: {
      api: 'gms',
      request: requests.listShopConcepts(shopUUID, {
        fields: '*',
        ...params
      })
    }
  })

export const getShopConcept = (conceptUUID: string) =>
  AsyncAction<GETConceptResponse>({
    type: [types.GET_SHOP_CONCEPT, types.GET_SHOP_CONCEPT_SUCCESS, types.GET_SHOP_CONCEPT_FAILED],
    payload: {
      api: 'gms',
      request: requests.getShopConcept(conceptUUID)
    }
  })
